<template>
  <CFooter :fixed="false">
    <div>
      <a href="http://www.innolux.com/" target="_blank">INNOLUX</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} 新技術架構發展部 / 架構規劃二課.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="http://www.innolux.com/">INNOLUX</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
